import { defineComponent as _defineComponent } from 'vue'
import MyProjectsSection from '@/views/my-projects/components/MyProjectsSection.vue';
import InvoicesTable from '@/views/my-projects/components/invoices/InvoicesTable.vue';
import { computed } from 'vue';
import { fakeInvoices, InvoiceStatus } from '@/views/my-projects/components/invoices/fakeData';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicesIncoming',
  setup(__props) {

const ingoingInvoices = computed(() => fakeInvoices.filter((invoice) => [
  InvoiceStatus.New,
  InvoiceStatus.Open,
  InvoiceStatus.Overdue,
  InvoiceStatus.Paid
].includes(invoice.status)));

return { __sfc: true,ingoingInvoices, MyProjectsSection, InvoicesTable }
}

})